<template>
  <div :class="isMobile ? 'login mblogin' : 'login'">
    <div v-if="isMobile" class="mblogin">
      <div class="logintop">
        <img src="../../assets/img/home/ht.png" />
      </div>
      <div class="logo">
        <img src="../../assets/img/login.png" />
      </div>
      <div class="login_from">
        <!-- 注册 -->
        <div
          class="infoli infoli1"
          style="display:justifyContent: space-around"
        >
          <el-form :inline="true" :model="form" ref="form1" :rules="rules1">
            <div class="infoli_title wiwt font_bo">新用户注册</div>
            <div class="infoli_title_en fontsty">
              BRAND INTELLIGENCE, SHARED FUTURE
            </div>
            <div class="magbutt">
              <div class="szie18zt">手机号:</div>
              <div
                class="magrtop mbzce formitem"
                style="width: 100%; height: 100%"
              >
                <el-form-item label prop="phone">
                  <el-input
                    v-model.trim="form.phone"
                    placeholder="请输入手机号"
                    prefix-icon="el-icon-mobile"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="flex">
                <div class="verification">
                  <el-form-item label prop="code">
                    <el-input
                      v-model="form.code"
                      placeholder="验证码"
                      oninput="value=value.replace(/[^\d]/g,'')"
                      maxlength="6"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="wngji_yzm">
                  <span class="font_bo cursor" @click="send" v-if="isSend"
                    >发送验证码</span
                  >
                  <span class="font_bo" v-if="!isSend">{{ sendmsg }}</span>
                </div>

                <!-- <div class="verifi_div">
                  <p class="verifi verifip1  center cursor szie18zt font_bo" @click="send" v-if="isSend">
                    发送验证码
                  </p>
                  <p class="verifi center cursor" v-if="!isSend">{{ sendmsg }}</p>
                </div>-->
              </div>
            </div>
            <div class="magbutt mbyhumn mto20 formitem">
              <div class="password szie18zt">
                <span>用户名:</span>
              </div>
              <div class="magrtop">
                <el-form-item label prop="name">
                  <el-input v-model="form.name" placeholder="用户名"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="szie18zt">邮箱:</div>
            <div class="magrtop mbzce formitem" style="width: 100%">
              <el-form-item label prop="account">
                <el-input
                  v-model.trim="form.account"
                  placeholder="企业邮箱"
                  prefix-icon="el-icon-message"
                ></el-input>
              </el-form-item>
            </div>
            <div class="magbutt mbyhumn mto20 formitem">
              <div class="password szie18zt">
                <span>公司名称:</span>
              </div>
              <div class="magrtop">
                <el-form-item label prop="companyName">
                  <el-input
                    v-model="form.companyName"
                    placeholder="公司名称"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="magbutt mbyhumn formitem">
              <div class="password szie18zt">
                <span>密码:</span>
              </div>
              <div class="magrtop">
                <el-form-item label prop="password">
                  <el-input
                    placeholder="6到18位数密码"
                    prefix-icon="el-icon-lock"
                    v-model="form.password"
                    show-password
                    maxlength="18"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="magbutt mbyhumn formitem">
              <div class="password szie18zt">
                <span>再次确认:</span>
              </div>
              <div class="magrtop">
                <el-form-item label prop="againPassword">
                  <el-input
                    prefix-icon="el-icon-lock"
                    placeholder="6到18位数密码"
                    v-model="form.againPassword"
                    show-password
                    maxlength="18"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="magbutt mbyhumn mto20 formitem">
              <div class="password szie18zt">
                <span>推荐码:</span>
              </div>
              <div class="magrtop">
                <el-form-item label prop="referralCode">
                  <el-input
                    :readonly="form.referralCode"
                    v-model="form.referralCode"
                    placeholder="推荐码"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="agreement">
              <span class="agreement_1 center cursor" @click="read">
                <i v-if="iconstuts" class="el-icon-check size12"></i>
              </span>
              <span class="agreement_2 size12 cursor">
                我已阅读并同意
                <span class="agreement_e" @click="openUrl(1)">
                  <span class="font_a">《FOSHO用户协议》</span> </span
                >和
                <span class="agreement_e" @click="openUrl(2)">
                  <span class="font_a">隐私政策</span>
                </span>
              </span>
            </div>
            <div class="register w90 center cursor" @click="register('form1')">
              注册
            </div>
            <div class="register_sher center" style="padding-bottom: 50px">
              <span class="szie12 register_sher1">已有账户?</span>
              <span class="sher szie12 cursor register_sher2" @click="goLogin"
                >去登录</span
              >
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <div v-else class="pclogin">
      <div class="login_img_top cursor">
        <img src="../../assets/img/home/ht.png" alt @click="gogwhome" />
      </div>
      <div class="top">
        <div class="login_img">
          <img src="../../assets/img/login.png" alt />
        </div>
        <div class="login_from">
          <!-- 注册 -->
          <div
            class="infoli infoli1"
            style="display:justifyContent: space-around"
          >
            <el-form :inline="true" :model="form" ref="form1" :rules="rules1">
              <div class="infoli_title wiwt font_bo">新用户注册</div>
              <div class="infoli_title_en fontsty">
                BRAND INTELLIGENCE, SHARED FUTURE
              </div>
              <div class="magbutt">
                <div class="szie18zt">
                  <span style="color: #f56c6c">*</span>手机号:
                </div>
                <div class="magrtop mbzce formitem" style="width: 100%">
                  <el-form-item label prop="phone">
                    <el-input
                      v-model.trim="form.phone"
                      placeholder="请输入手机号"
                      prefix-icon="el-icon-mobile"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="flex formitem">
                  <div class="verification">
                    <el-form-item label prop="code">
                      <el-input
                        v-model="form.code"
                        placeholder="验证码"
                        oninput="value=value.replace(/[^\d]/g,'')"
                        maxlength="6"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="verifi_div">
                    <p
                      class="verifi verifip1 center cursor szie18zt font_bo"
                      @click="send"
                      v-if="isSend"
                    >
                      发送验证码
                    </p>
                    <p class="verifi center cursor" v-if="!isSend">
                      {{ sendmsg }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="magbutt mbyhumn mto20 formitem">
                <div class="szie18zt">
                  <span style="color: #f56c6c">*</span>用户名:
                </div>
                <div class="magrtop">
                  <el-form-item label prop="name">
                    <el-input
                      v-model="form.name"
                      placeholder="用户名"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="szie18zt">
                <span style="color: #f56c6c">*</span>邮箱:
              </div>
              <div class="magrtop mbzce formitem" style="width: 100%">
                <el-form-item label prop="account">
                  <el-input
                    v-model.trim="form.account"
                    placeholder="企业邮箱"
                    prefix-icon="el-icon-message"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="magbutt mbyhumn mto20 formitem">
                <div class="szie18zt">
                  <span style="color: #f56c6c">*</span>公司名称:
                </div>
                <div class="magrtop">
                  <el-form-item label prop="companyName">
                    <el-input
                      v-model="form.companyName"
                      placeholder="公司名称"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="magbutt mbyhumn formitem">
                <div class="szie18zt">
                  <span style="color: #f56c6c">*</span>密码:
                </div>
                <div class="magrtop">
                  <el-form-item label prop="password">
                    <el-input
                      placeholder="6到18位数密码"
                      prefix-icon="el-icon-lock"
                      v-model="form.password"
                      show-password
                      maxlength="18"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="magbutt mbyhumn formitem">
                <div class="szie18zt">
                  <span style="color: #f56c6c">*</span>再次确认:
                </div>
                <div class="magrtop">
                  <el-form-item label prop="againPassword">
                    <el-input
                      prefix-icon="el-icon-lock"
                      placeholder="6到18位数密码"
                      v-model="form.againPassword"
                      show-password
                      maxlength="18"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="magbutt mbyhumn mto20 formitem">
                <div class="password szie18zt">
                  <span>推荐码:</span>
                </div>
                <div class="magrtop">
                  <el-form-item label prop="referralCode">
                    <el-input
                      :readonly="form.referralCode"
                      v-model="form.referralCode"
                      placeholder="推荐码"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="agreement">
                <span class="agreement_1 center cursor" @click="read">
                  <i v-if="iconstuts" class="el-icon-check size12"></i>
                </span>
                <span class="agreement_2 size12 cursor">
                  我已阅读并同意
                  <span class="agreement_e" @click="openUrl(1)">
                    <span class="font_a">《FOSHO用户协议》</span> </span
                  >和
                  <span class="agreement_e" @click="openUrl(2)">
                    <span class="font_a">隐私政策</span>
                  </span>
                </span>
              </div>
              <div
                class="register w90 center cursor"
                @click="register('form1')"
              >
                注册
              </div>
              <div class="register_sher center">
                <span class="szie12 register_sher1">已有账户?</span>
                <span class="sher szie12 cursor register_sher2" @click="goLogin"
                  >去登录</span
                >
              </div>
            </el-form>
          </div>
        </div>
      </div>
      <div class="nologins" v-if="dialogVisible">
        <div class="nologins_title">
          <div class="nologins_title_icon">
            <i class="el-icon-close cursor" @click="dialogVisible = false"></i>
          </div>
          <div class="nologins_title_img">
            <img src="../../assets/img/home/kf2.png" alt />
          </div>
          <div style="font-size: 16px" class="nologins_title_text center">
            注册采用邀请制，请联系客服。
          </div>
        </div>
      </div>
      <div class="buticp">
        <icp></icp>
      </div>
    </div>
  </div>
</template>
<script>
import {
  LOGIN,
  CODE,
  PHONECODE,
  REGIST,
  CODEFORPASSWORD,
  PASSWORD,
  QUERY,
  RECORDS,
  QRCODEURL,
  GETURLBYID,
} from "../../api/login";
import { QUERYMAINPERMIT } from "../../api/heder";
import icp from "../icp/icp.vue";
import util from "@/utils/util";
const Base64 = require("js-base64").Base64;
export default {
  components: {
    icp,
  },
  data() {
    let passwords = (rule, value, callback) => {
      //6位数密码校验
      if (!value) {
        return callback(new Error("密码不能为空"));
      } else {
        if (!/^[0-9]*$/.test(value)) {
          callback(new Error("请输入六位的数字密码"));
        } else {
          callback();
        }
      }
    };
    let email = (rule, value, callback) => {
      // 邮箱正则校验
      if (!value) {
        return callback(new Error("邮箱不能为空"));
      } else {
        if (
          !/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(
            value
          )
        ) {
          callback(new Error("请输入正确邮箱地址"));
        } else {
          callback();
        }
      }
    };
    let phone = (rule, value, callback) => {
      // 邮箱正则校验
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        if (
          !/^1((34[0-8])|(8\d{2})|(([35][0-35-9]|4[579]|66|7[0-9]|9[0-9])\d{1}))\d{7}$/.test(
            value
          )
        ) {
          callback(new Error("请输入正确手机号"));
        } else {
          callback();
        }
      }
    };
    let emailphone = (rule, value, callback) => {
      // 邮箱正则校验
      if (!value) {
        return callback(new Error("账号不能为空"));
      } else {
        if (
          !/^1((34[0-8])|(8\d{2})|(([35][0-35-9]|4[579]|66|7[0-9]|9[0-9])\d{1}))\d{7}$/.test(
            value
          ) &&
          !/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(
            value
          )
        ) {
          callback(new Error("请输入正确手机号或邮箱"));
        } else {
          callback();
        }
      }
    };
    return {
      dialogVisible: false,
      isSend: true, // 发送验证码
      isSendForget: true, // 修改发送验证码
      sendmsg: "发送验证码",
      sendmsgforgetcomlis: "发送验证码", // 修改密码
      iconstuts: false, // 阅读协议
      form: {
        // 注册表单
        account: "",
        code: "",
        name: "",
        password: "",
        againPassword: "",
        type: "phone",
        companyName: "",
        referralCode: this.$route.query.referralCode
          ? this.$route.query.referralCode
          : null,
      },

      formForget: {
        // 修改密码表单
        account: "",
        code: "",
        newPassword: "",
        againPassword: "",
      },
      rules: {
        // 注册表单校验
        account: [{ required: true, trigger: "onBlur" }],
        code: [{ required: true, trigger: "onBlur" }],
        name: [{ required: true, trigger: "onBlur" }],
        companyName: [{ required: true, trigger: "onBlur" }],
        password: [{ required: true, trigger: "onBlur" }],
        againPassword: [{ required: true, trigger: "onBlur" }],
      },
      rules1: {
        //注册表单校验
        phone: [
          {
            required: true,
            message: "手机号不能为空",
            trigger: ["blur", "change"],
          },
          { validator: phone, trigger: ["blur", "change"] },
        ],
        account: [
          {
            required: true,
            message: "邮箱不能为空",
            trigger: ["blur", "change"],
          },
          { validator: email, trigger: ["blur", "change"] },
        ],
        code: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: "名称不能为空",
            trigger: ["blur", "change"],
          },
        ],
        companyName: [
          {
            required: true,
            message: "公司名称不能为空",
            trigger: ["blur", "change"],
          },
        ],
        password: [
          {
            required: true,
            message: "密码不能为空",
            trigger: ["blur", "change"],
          },
        ],
        againPassword: [
          {
            required: true,
            message: "确认密码不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      rules2: {
        //登录表单校验
        account: [
          {
            required: true,
            message: "邮箱不能为空",
            trigger: ["blur", "change"],
          },
          { validator: emailphone, trigger: ["blur", "change"] },
        ],
        password: [
          {
            required: true,
            message: "密码不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      rules3: {
        // 修改密码表单校验
        account: [
          {
            required: true,
            message: "账号不能为空",
            trigger: ["blur", "change"],
          },
          { validator: emailphone, trigger: ["blur", "change"] },
        ],
        code: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: "名称不能为空",
            trigger: ["blur", "change"],
          },
        ],
        newPassword: [
          {
            required: true,
            message: "密码不能为空",
            trigger: ["blur", "change"],
          },
        ],
        againPassword: [
          {
            required: true,
            message: "确认密码不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      url: process.env.VUE_APP_BASE_API,
      queryMainPermitList: [],
      cotype: "",
      endDate: "",
      isMobile: null,
      referralCode: null,
    };
  },
  created() {
    this.isMobile = util.isMobile();
    this.referralCode = this.$route.query.referralCode;
  },
  methods: {
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    //跳官网
    gogwhome() {
      if (this.url == "/dev") {
      } else if (this.url == "/prod") {
        window.open("https://www.foshoaff.com/");
      } else if (this.url == "/test") {
        window.open("https://sit.foshoaff.com/");
      }
    },
    /**
     * 发送验证码 注册
     */
    send() {
      if (!this.form.phone) {
        this.$message({
          message: "请填写手机号后获取验证码",
          type: "warning",
        });
      } else if (
        !/^1((34[0-8])|(8\d{2})|(([35][0-35-9]|4[579]|66|7[0-9]|9[0-9])\d{1}))\d{7}$/.test(
          this.form.phone
        )
      ) {
        this.$message({
          message: "请填写正确的手机号后获取验证码",
          type: "warning",
        });
      } else {
        let data = {
          phone: this.form.phone,
          type: "phone",
        };
        PHONECODE(data).then((res) => {
          if (res.data.code == "error") {
            this.$message.error(res.data.msg);
            let timer = 60;
            this.isSend = true;
            this.sendmsg = timer;
          } else {
            this.isSend = false;
            let timer = 60;
            this.$alert(
              "我们已将验证码发送至您的手机，请注意查看您的收件箱或垃圾短信。",
              "发送成功",
              {
                confirmButtonText: "确定",
                callback: (action) => {},
              }
            );
            this.sendmsg = timer + "s";
            this.timeFun = setInterval(() => {
              --timer;
              this.sendmsg = timer + "s";
              if (timer == 0) {
                this.isSend = true;
                this.sendmsg = "重新发送";
                clearInterval(this.timeFun);
              }
            }, 1000);
          }
        });
      }
    },
    // 发送验证码 (修改密码) forget
    sendForget() {
      if (!this.formForget.account) {
        this.$message({
          message: "请填写账号后获取验证码",
          type: "warning",
        });
      } else if (
        !/^1((34[0-8])|(8\d{2})|(([35][0-35-9]|4[579]|66|7[0-9]|9[0-9])\d{1}))\d{7}$/.test(
          this.formForget.account
        ) &&
        !/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(
          this.formForget.account
        )
      ) {
        this.$message({
          message: "请填写正确的账号后获取验证码",
          type: "warning",
        });
      } else {
        let data = {
          account: this.formForget.account,
        };
        if (
          /^1((34[0-8])|(8\d{2})|(([35][0-35-9]|4[579]|66|7[35678]|9[1389])\d{1}))\d{7}$/.test(
            this.formForget.account
          )
        ) {
          data.type = "phone";
        } else {
          data.type = "email";
        }
        CODEFORPASSWORD(data).then((res) => {
          if (res.data.code == "error") {
            this.$message.error(res.data.msg);
            let timer = 60;
            this.isSendForget = true;
            this.sendmsgforgetcomlis = timer;
          } else {
            this.isSendForget = false;
            let timer = 60;
            this.sendmsgforgetcomlis = timer + "s";
            this.timeFuns = setInterval(() => {
              --timer;
              this.sendmsgforgetcomlis = timer + "s";
              if (timer == 0) {
                this.isSendForget = true;
                this.sendmsgforgetcomlis = "重新发送";
                clearInterval(this.timeFuns);
              }
            }, 1000);
          }
        });
      }
    },

    /**
     * read()勾选协议
     */
    read() {
      this.iconstuts = !this.iconstuts;
    },

    // 获取cookie
    getCookie: function (key) {
      if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(key + "=");
        if (start !== -1) {
          start = start + key.length + 1;
          var end = document.cookie.indexOf(";", start);
          if (end === -1) end = document.cookie.length;
          return unescape(document.cookie.substring(start, end));
        }
      }
      return "";
    },
    /**
     * goRegister去登录
     */
    goLogin() {
      this.$router.push("/login");
    },
    /**
     * register注册
     */
    register(formName) {
      if (!this.iconstuts) {
        this.$message({
          message: "请阅读用户协议并勾选",
          type: "warning",
        });
        return;
      }
      let rules1 = new Promise((resolve, reject) => {
        this.$refs["form1"].validate((valid) => {
          if (valid) {
            resolve();
          }
        });
      });
      Promise.all([rules1]).then(() => {
        this.saveChannel();
      });
      window._hmt.push([
        "_trackEvent",
        "action",
        "注册",
        "click",
        "regLook",
        this.form,
      ]);
    },
    saveChannel() {
      if (this.form.password !== this.form.againPassword) {
        this.$message({
          message: "两次输入密码不一致，请重新输入！",
          type: "warning",
        });
        return;
      }
      REGIST(this.form).then((res) => {
        if (res.data.code == "error") {
          this.$message.error(res.data.msg);
        } else {
          this.$message({
            message: "注册成功",
            type: "success",
          });
          let token = res.data.body;
          window.localStorage.setItem("token", token);
          if (this.isMobile) {
            this.$router.push("./starbrand-m");
          } else {
            this.$router.push("./info");
          }
          let str = -1;
          localStorage.setItem("isSelect", str);
        }
      });
    },
    /**
     * queryInfo
     * 获取登录信息
     */
    queryUserInfo() {
      QUERY().then((res) => {
        // debugger
        if (res.data.code == "success") {
          RECORDS({ userId: res.data.body.id }).then((res2) => {
            if (res2.data.body.restDay) {
              if (this.isMobile) {
                this.$router.push("./starbrand-m");
              } else {
                this.$router.push("./insight");
              }
              let str = "洞察情报";
              localStorage.setItem("isSelect", str);
              localStorage.setItem("validParam", "ig");
              localStorage.setItem("validParam", "ig");
            } else {
              if (this.isMobile) {
                this.$router.push("./starbrand-m");
              } else {
                this.$router.push("./info");
              }
              let str = -1;
              localStorage.setItem("isSelect", str);
            }
          });
        } else {
          this.$message({
            message: "获取用户信息失败",
            type: "error",
          });
        }
      });
    },
    openUrl(e) {
      if (e == 1) {
        GETURLBYID({ id: 1 }).then((res) => {
          if (res.data.code == "success") {
            this.termsOfUse = res.data.body;
            window.open(this.termsOfUse, "_blank");
          }
        });
      } else {
        GETURLBYID({ id: 5 }).then((res) => {
          if (res.data.code == "success") {
            this.privacyPolicy = res.data.body;
            window.open(this.privacyPolicy, "_blank");
          }
        });
      }
      this.iconstuts = true;
    },
  },
};
</script>
<style lang="less" scoped>
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.mblogin {
  background-color: #fff !important;

  .mbicp {
    // position: absolute;
    padding-top: 15px;
    // bottom: 0;
    background-color: #fff;
    text-align: center;
  }
}

.login {
  overflow-y: scroll;

  .pclogin {
    .el-input__inner {
      border: 1px solid #d8d8d8;
    }

    .el-input--prefix .el-input__inner {
      padding-left: 50px;
      font-size: 18px;
    }

    .el-icon-check:before {
      font-size: 16px;
    }

    .el-input__icon:after {
      font-size: 30px !important;
    }

    .el-icon-message:before {
      font-size: 30px;
    }

    .el-input__icon {
      line-height: 60px !important;
    }

    .el-icon-lock:before {
      font-size: 30px !important;
    }
  }

  .mblogin {
    width: 100%;
    height: 100%;

    .logintop {
      width: 100px;
      display: inline-block;
      position: absolute;
      top: 25px;
      left: 20px;
      z-index: 99;

      img {
        width: 100%;
      }
    }

    .logo {
      width: 150px;
      display: inline-block;
      position: absolute;
      top: 65px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 99;

      img {
        width: 100%;
      }
    }

    /deep/.el-input__icon {
      width: 50px;
      font-size: 24px;
      line-height: 60px !important;
      transform: translateY(-5px);
    }

    .login_from {
      width: 100%;
      height: 100%;
      position: relative;

      .infoli_two {
        // height: 100%;
        min-height: 540px;
        width: 100%;
        border-radius: 5px;
        position: absolute;
        background: #fff;
        padding: 200px 0px 0px 0px !important;
        box-sizing: border-box;

        .infoli_title {
          width: 100%;
          font-size: 22px;
          text-align: center;
          margin-bottom: 20px;
        }

        .magrtop_input {
          margin: 9px 0px 50px 0px;
          height: 36px;
        }
      }

      .password {
        span {
          display: inline-block;
          width: 50%;
        }
      }

      .infoli1 {
        width: 70%;
        height: 100%;
        position: absolute;
        left: 100px;
        background: #fff;
        border-radius: 5px;
        padding: 15px 15px;
        padding: 240px 0px 0px 0px !important;
        box-sizing: border-box;

        .mbzce {
          margin-bottom: 30px;
        }

        .mbyhumn {
          margin-top: 30px;
        }

        .mto20 {
          margin-top: 10px !important;
        }

        div {
          width: 100%;
          height: 100% !important;
        }

        .infoli_title {
          text-align: center;
          font-size: 22px;
          margin-bottom: 20px;
        }

        .infoli_title_en {
          font-family: "AiDeep";
          text-align: center;
        }

        .formitem {
          margin-bottom: 20px !important;
        }

        // .verification {
        //   width: 30%;
        //   height: 50Px;
        // }

        .verifi_div {
          width: auto;
          height: 100%;
          position: relative;

          // box-sizing: border-box;
          .verifi {
            height: 100%;
            line-height: 100%;
            margin-left: 10px;
            padding-top: 16px;
            border-bottom: 2px solid #000;
          }
        }

        .size {
          font-size: 14px;
          margin-top: 10px;
          margin-bottom: 10px;
        }
      }

      .wngji {
        height: 100%;
        width: 100%;
        border-radius: 5px;
        position: absolute;
        background: #fff;
        padding: 240px 0px 0px 0px !important;
        box-sizing: border-box;

        .formitem {
          margin-bottom: 15px;
        }

        div {
          width: 100%;
          // margin-bottom: 20px;
        }

        .w90 {
          width: 90%;
          margin: 0 auto;
        }

        .infoli_title {
          text-align: center;
          font-size: 22px;
          margin-bottom: 20px;
        }

        .infoli_title_en {
          font-family: "AiDeep";
          text-align: center;
          margin-bottom: 20px;
        }

        .size {
          font-size: 14px;
          margin-top: 10px;
          margin-bottom: 10px;
        }

        .mbsub {
          margin-top: 25px;
        }
      }
    }

    .agreement {
      height: 30px;
      line-height: 30px;
      position: relative;
      margin-top: 20px;
      margin-bottom: 20px;

      .agreement_1 {
        display: inline-block;
        width: 20px;
        height: 20px;
        line-height: 20px;
        border: 1px solid #000;
        border-radius: 5px;
        position: absolute;
        left: 0;
        top: 10px;
        margin-right: 5px;
      }

      .agreement_2 {
        display: inline-block;
        margin-left: 25px;
        margin-top: 6px;
        font-size: 12px;
        color: #202224;
        margin-bottom: 37px;
      }
    }

    .register {
      width: 90%;
      height: 40px;
      line-height: 40px;
      border-radius: 5px;
      font-size: 14px;
      background: rgb(196, 79, 124);
      color: #fff;
      margin: 0 auto;
    }

    .register_sher {
      width: 90%;
      margin: 20px 0;

      span {
        font-size: 12px;
      }

      .sher {
        display: inline-block;
        color: rgb(94, 144, 255);
        border-bottom: 1px solid rgb(94, 144, 255);
        margin-left: 20px;
      }
    }

    .infoli {
      width: 100%;
      height: 100%;
      position: absolute;
      background: #fff;
      border-radius: 5px;
      padding: 89px 57px 69px 57px;
      box-sizing: border-box;

      .mbzce {
        margin-bottom: 40px;
      }

      .mbyhumn {
        margin-top: 40px;
      }

      div {
        width: 100%;
      }

      .w90 {
        width: 90%;
        margin: 0 auto;
      }

      .infoli_title {
        text-align: center;
        font-size: 32px;
      }

      .infoli_title_en {
        font-family: "AiDeep";
        font-size: 18px;
        text-align: center;
        margin-top: 20px;
      }

      .size {
        font-size: 14px;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
  }
}

.buticp {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999999999;
}

.nologins {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5, #000);

  .nologins_title {
    width: 400px;
    height: 400px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -200px;
    margin-left: -200px;
    background: #fff;
    border-radius: 15px;
    padding: 20px;
  }

  .nologins_title_icon {
    width: 100%;
    text-align: right;
    font-size: 26px;
    padding-right: 10px;

    i {
      color: #000;
    }
  }

  .nologins_title_img {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    margin-top: 40px;

    img {
      width: 200px;
      height: 200px;
      display: inline-block;
      margin: 0 auto;
    }
  }

  .nologins_title_text {
    width: 100%;
    margin-top: 50px;
    font-size: 22px;
  }
}

input {
  outline: none;
  /*点击之后。不出现边框*/
}

.agreement_e {
  color: #5e90ff;
}

@media screen and (max-width: 2560px) {
  .mbo10 {
    display: inline-block;
    margin-bottom: 10px;
  }

  .pclogin {
    .wngji_yzm {
      height: 40px;
      line-height: 40px;
      margin-left: 20px;

      span {
        border-bottom: 2px solid;
      }
    }
  }

  .mblogin {
    .wngji_yzm {
      height: 40px;
      line-height: 40px;
      margin-left: 20px;

      span {
        border-bottom: 2px solid;
      }
    }

    .infoli1 {
      width: 100% !important;
      height: 100% !important;
      left: 0 !important;
      position: absolute;
      background: #fff;
      border-radius: 5px !important;
      padding: 15px 15px !important;
      padding: 27px 27px 39px 27px !important;
      box-sizing: border-box;

      .mbzce {
        margin-bottom: 30px;
      }

      .mbyhumn {
        margin-top: 30px;
      }

      .mto20 {
        margin-top: 20px;
      }

      .formitem {
        margin-bottom: 30px;
      }

      div {
        width: 100%;
      }

      .infoli_title {
        text-align: center;
        font-size: 22px;
        margin-bottom: 8px !important;
      }

      .infoli_title_en {
        font-family: "AiDeep";
        text-align: center;
        font-size: 12px !important;
      }

      .verification {
        width: 50%;
        height: 50px;
      }

      .verifi_div {
        width: auto;
        height: 100%;
        position: relative;

        // box-sizing: border-box;
        .verifi {
          height: 100%;
          line-height: 100%;
          margin-left: 10px;
          padding-top: 16px;
          border-bottom: 2px solid #000;
        }
      }

      .size {
        font-size: 14px;
        margin-top: 10px;
        margin-bottom: 10px;
      }

      .agreement {
        height: 30px;
        line-height: 30px;
        position: relative;
        margin-top: 0px !important;
        margin-bottom: 0px !important;
      }

      .agreement_2 {
        display: inline-block;
        margin-left: 25px !important;
        font-size: 12px !important;
        color: #202224;
        margin-bottom: 37px !important;
      }
    }
  }

  .jies {
    text-align: center;
    font-size: 16px;
    font-family: "AiDeep";
    margin-bottom: 50px;
  }

  .szie18zt {
    font-size: 12px;
  }

  .login_img_top {
    width: 196px;
    height: 33px;
    position: fixed;
    left: 31px;
    top: 31px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .login {
    width: 100%;
    height: 100%;
    background: #f4f4f4;
    position: fixed;
    left: 0;
    top: 0;
    padding: 20px;
    box-sizing: border-box;

    .top {
      width: 100%;
      height: 100vh;
      margin: auto 0;
      text-align: left;
      display: flex;
      padding-top: 43px;
      padding-left: 48px;
      padding-bottom: 105px;
      box-sizing: border-box;

      .login_from {
        width: 40%;
        height: 100%;
        position: relative;

        .infoli_two {
          height: 80%;
          min-height: 450px;
          width: 70%;
          border-radius: 5px;
          position: absolute;
          left: 100px;
          top: 80px;
          background: #fff;
          padding: 49px 27px 39px 27px;
          box-sizing: border-box;

          .infoli_title {
            width: 100%;
            font-size: 22px;
            text-align: center;
            margin-bottom: 20px;
          }

          .magrtop_input {
            margin: 9px 0px 50px 0px;
            height: 36px;
          }
        }

        .password {
          span {
            display: inline-block;
            width: 50%;
          }
        }

        .infoli1 {
          width: 70%;
          // height: 100%;
          min-height: 700px;
          position: absolute;
          left: 100px;
          top: -50px;
          // margin-top: -55%;
          background: #fff;
          border-radius: 5px;
          padding: 15px 15px;
          padding: 49px 27px 29px 27px;
          box-sizing: border-box;

          .mbzce {
            margin-bottom: 30px;
          }

          .mbyhumn {
            margin-top: 30px;
          }

          .mto20 {
            margin-top: 20px;
          }

          .formitem {
            margin-bottom: 30px;
          }

          div {
            width: 100%;
          }

          .infoli_title {
            text-align: center;
            font-size: 22px;
            margin-bottom: 20px;
          }

          .infoli_title_en {
            font-family: "AiDeep";
            text-align: center;
          }

          .verification {
            width: 30%;
            height: 50px;
          }

          .verifi_div {
            width: auto;
            height: 100%;
            position: relative;

            // box-sizing: border-box;
            .verifi {
              height: 100%;
              line-height: 100%;
              margin-left: 10px;
              padding-top: 16px;
              border-bottom: 2px solid #000;
            }
          }

          .size {
            font-size: 14px;
            margin-top: 10px;
            margin-bottom: 10px;
          }
        }

        .wngji {
          height: 85%;
          width: 70%;
          border-radius: 5px;
          position: absolute;
          left: 100px;
          top: 80px;
          background: #fff;
          padding: 45px 27px 69px 27px;
          box-sizing: border-box;
          // .mbzce {
          //   margin-bottom: 40px;
          // }

          .formitem {
            margin-bottom: 15px;
          }

          div {
            width: 100%;
            // margin-bottom: 20px;
          }

          .w90 {
            width: 90%;
            margin: 0 auto;
          }

          .infoli_title {
            text-align: center;
            font-size: 32px;
            margin-bottom: 20px;
          }

          .infoli_title_en {
            font-family: "AiDeep";
            text-align: center;
            margin-bottom: 20px;
          }

          .size {
            font-size: 14px;
            margin-top: 10px;
            margin-bottom: 10px;
          }

          .mbsub {
            margin-top: 25px;
          }
        }
      }
    }
  }

  .agreement {
    height: 30px;
    line-height: 30px;
    position: relative;
    margin-top: 50px;
    margin-bottom: 50px;

    .agreement_1 {
      display: inline-block;
      width: 20px;
      height: 20px;
      line-height: 20px;
      border: 1px solid #000;
      border-radius: 5px;
      position: absolute;
      left: 0;
      top: 10px;
      margin-right: 5px;
    }

    .agreement_2 {
      display: inline-block;
      margin-left: 25px;
      margin-top: 6px;
      font-size: 12px;
      color: #202224;
      margin-bottom: 37px;
    }
  }

  .register {
    width: 90%;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    font-size: 14px;
    background: rgb(196, 79, 124);
    color: #fff;
    margin: 0 auto;
  }

  .register_sher {
    width: 90%;
    margin: 20px 0;

    span {
      font-size: 12px;
    }

    .sher {
      display: inline-block;
      color: rgb(94, 144, 255);
      border-bottom: 1px solid rgb(94, 144, 255);
      margin-left: 20px;
    }
  }
}

@media screen and (min-width: 2560px) {
  .wngji_yzm {
    height: 56px;
    line-height: 56px;
    margin-left: 20px;

    span {
      border-bottom: 2px solid;
    }
  }

  .wiwt {
    font-size: 32px;
  }

  .jies {
    text-align: center;
    font-size: 18px;
    font-family: "AiDeep";
    margin-bottom: 20px;
  }

  .szie18zt {
    font-size: 18px;
  }

  .login_img_top {
    width: 196px;
    height: 33px;
    position: fixed;
    left: 41px;
    top: 41px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .login {
    width: 100%;
    height: 100%;
    background: #f4f4f4;
    position: fixed;
    left: 0;
    top: 0;
    padding: 20px;
    box-sizing: border-box;

    .top {
      width: 100%;
      height: 100vh;
      margin: auto 0;
      text-align: left;
      display: flex;
      padding-top: 43px;
      padding-left: 48px;
      padding-bottom: 105px;
      box-sizing: border-box;

      .login_from {
        width: 40%;
        height: 100%;
        position: relative;

        .infoli_two {
          height: 870px;
          min-height: 450px;
          width: 630px;
          border-radius: 5px;
          position: absolute;
          left: 100px;
          top: 160px;
          background: #fff;
          padding: 89px 57px 69px 57px;
          box-sizing: border-box;

          .infoli_title {
            width: 100%;
            font-size: 32px;
            text-align: center;
            margin-bottom: 20px;
          }

          .magrtop_input {
            margin: 17px 0px 40px 0px;
            height: 56px;
          }
        }

        .password {
          span {
            display: inline-block;
            width: 50%;
          }
        }

        .infoli {
          width: 70%;
          height: 89%;
          position: absolute;
          left: 100px;
          top: 50%;
          margin-top: -50%;
          background: #fff;
          border-radius: 5px;
          // padding: 30px 30px;
          padding: 89px 57px 69px 57px;
          box-sizing: border-box;

          .mbzce {
            margin-bottom: 40px;
          }

          .mbyhumn {
            margin-top: 40px;
          }

          div {
            width: 100%;
          }

          .w90 {
            width: 90%;
            margin: 0 auto;
          }

          .infoli_title {
            text-align: center;
            font-size: 32px;
          }

          .infoli_title_en {
            font-family: "AiDeep";
            font-size: 18px;
            text-align: center;
            margin-top: 20px;
          }

          .size {
            font-size: 14px;
            margin-top: 10px;
            margin-bottom: 10px;
          }
        }

        .wngji {
          width: 70%;
          height: 80%;
          border-radius: 5px;
          position: absolute;
          left: 100px;
          top: 160px;
          background: #fff;
          padding: 89px 57px 69px 57px;
          box-sizing: border-box;

          // .mbzce {
          //   margin-bottom: 40px;
          // }
          // .mbyhumn {
          //   margin-top: 40px;
          // }
          .formitem {
            margin-bottom: 15px;
          }

          .mt2o {
            margin-top: 20px;
          }

          div {
            width: 100%;
          }

          .infoli_title {
            text-align: center;
            font-size: 32px;
          }

          .infoli_title_en {
            font-family: AiDeep;
            text-align: center;
          }

          .verification {
            width: 30%;
            height: 40px;
          }

          .verifi_div {
            width: auto;
            height: 100%;
            padding-top: 6px;

            .verifi {
              width: 90px;
              height: 19px;
              line-height: auto;
              margin-left: 10px;
              border-bottom: 2px solid #000;
            }

            .verifip1 {
              width: 90px;
              height: 19px;
              line-height: 19px;
              margin-left: 10px;
              border-bottom: 2px solid #000;
            }
          }

          .size {
            font-size: 14px;
            margin-top: 10px;
            margin-bottom: 10px;
          }

          .mbsub {
            margin-top: 100px;
          }
        }
      }
    }
  }

  .agreement {
    height: 10px;
    line-height: 10px;
    position: relative;
    margin-bottom: 50px;

    .agreement_1 {
      display: inline-block;
      width: 16px;
      height: 16px;
      line-height: 10px;
      border: 1px solid #000;
      border-radius: 5px;
      position: absolute;
      left: 0;
      top: 20px;
      margin-right: 10px;
    }

    .agreement_2 {
      display: inline-block;
      margin-left: 24px;
      margin-top: 24px;
      font-size: 18px;
      color: #202224;
      margin-bottom: 57px;
    }
  }

  .register {
    width: 90%;
    height: 56px;
    line-height: 56px;
    border-radius: 5px;
    font-size: 20px;
    background: rgb(196, 79, 124);
    color: #fff;
    margin: 0 auto;
  }

  .register_two {
    margin-top: 40px;
  }

  .register_sher {
    width: 90%;
    margin: 40px 0;

    span {
      font-size: 18px;
    }

    .sher {
      display: inline-block;
      color: rgb(94, 144, 255);
      border-bottom: 1px solid rgb(94, 144, 255);
      margin-left: 20px;
    }
  }
}

@media only screen and (min-width: 1681px) and (max-width: 2559px) {
  .pclogin {
    .mbo10 {
      display: inline-block;
      margin-bottom: 10px;
    }

    .wngji_yzm {
      height: 40px;
      line-height: 40px;
      margin-left: 20px;

      span {
        border-bottom: 2px solid;
      }
    }

    .jies {
      text-align: center;
      font-size: 16px;
      font-family: "AiDeep";
      margin-bottom: 50px;
    }

    .szie18zt {
      font-size: 12px;
    }

    .login_img_top {
      width: 196px;
      height: 30px;
      position: fixed;
      left: 31px;
      top: 31px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .login {
      width: 100%;
      height: 100%;
      background: #f4f4f4;
      position: fixed;
      left: 0;
      top: 0;
      padding: 20px;
      box-sizing: border-box;

      .top {
        width: 100%;
        height: 100vh;
        margin: auto 0;
        text-align: left;
        display: flex;
        padding-top: 43px;
        padding-left: 48px;
        padding-bottom: 105px;
        box-sizing: border-box;

        .login_from {
          width: 40%;
          height: 100%;
          position: relative;

          .infoli_two {
            height: 80%;
            min-height: 540px;
            width: 70%;
            border-radius: 5px;
            position: absolute;
            left: 100px;
            top: 80px;
            background: #fff;
            padding: 49px 27px 39px 27px;
            box-sizing: border-box;

            .infoli_title {
              width: 100%;
              font-size: 22px;
              text-align: center;
              margin-bottom: 20px;
            }

            .magrtop_input {
              margin: 9px 0px 50px 0px;
              height: 36px;
            }
          }

          .password {
            span {
              display: inline-block;
              width: 50%;
            }
          }

          .infoli1 {
            width: 70%;
            height: 100%;
            position: absolute;
            left: 100px;
            // top: 50%;
            // margin-top: -55%;
            background: #fff;
            border-radius: 5px;
            padding: 15px 15px;
            padding: 49px 27px 39px 27px;
            box-sizing: border-box;

            .mbzce {
              margin-bottom: 30px;
            }

            .mbyhumn {
              margin-top: 30px;
            }

            .mto20 {
              margin-top: 20px;
            }

            div {
              width: 100%;
            }

            .infoli_title {
              text-align: center;
              font-size: 22px;
              margin-bottom: 20px;
            }

            .infoli_title_en {
              font-family: "AiDeep";
              text-align: center;
            }

            .verification {
              width: 30%;
              height: 50px;
            }

            .verifi_div {
              width: auto;
              height: 100%;
              position: relative;

              // box-sizing: border-box;
              .verifi {
                height: 100%;
                line-height: 100%;
                margin-left: 10px;
                padding-top: 16px;
                border-bottom: 2px solid #000;
              }
            }

            .size {
              font-size: 14px;
              margin-top: 10px;
              margin-bottom: 10px;
            }
          }

          .wngji {
            height: 85%;
            width: 70%;
            border-radius: 5px;
            position: absolute;
            left: 100px;
            top: 80px;
            background: #fff;
            padding: 45px 27px 69px 27px;
            box-sizing: border-box;

            // .mbzce {
            //   margin-bottom: 40px;
            // }
            .formitem {
              margin-bottom: 15px;
            }

            div {
              width: 100%;
              // margin-bottom: 20px;
            }

            .w90 {
              width: 90%;
              margin: 0 auto;
            }

            .infoli_title {
              text-align: center;
              font-size: 32px;
              margin-bottom: 20px;
            }

            .infoli_title_en {
              font-family: "AiDeep";
              text-align: center;
              margin-bottom: 20px;
            }

            .size {
              font-size: 14px;
              margin-top: 10px;
              margin-bottom: 10px;
            }

            .mbsub {
              margin-top: 25px;
            }
          }
        }
      }
    }

    .agreement {
      height: 30px;
      line-height: 30px;
      position: relative;
      margin-bottom: 50px;

      .agreement_1 {
        display: inline-block;
        width: 20px;
        height: 20px;
        line-height: 20px;
        border: 1px solid #000;
        border-radius: 5px;
        position: absolute;
        left: 0;
        top: 10px;
        margin-right: 5px;
      }

      .agreement_2 {
        display: inline-block;
        margin-left: 25px;
        margin-top: 6px;
        font-size: 12px;
        color: #202224;
        margin-bottom: 37px;
      }
    }

    .register {
      width: 90%;
      height: 40px;
      line-height: 40px;
      border-radius: 5px;
      font-size: 14px;
      background: rgb(196, 79, 124);
      color: #fff;
      margin: 0 auto;
    }

    .register_sher {
      width: 90%;
      margin: 20px 0;

      span {
        font-size: 12px;
      }

      .sher {
        display: inline-block;
        color: rgb(94, 144, 255);
        border-bottom: 1px solid rgb(94, 144, 255);
        margin-left: 20px;
      }
    }
  }
}

.login_img_top {
  width: 196px;
  height: 30px;
  position: fixed;
  left: 31px;
  top: 31px;

  img {
    width: 100%;
    height: 100%;
  }
}

.login_img {
  width: 60%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 632px;
    height: 577px;
  }
}
</style>
<style lang="less">
@media screen and (max-width: 2560px) {
  .login {
    .pclogin {
      .el-input__inner {
        border-radius: 5px;
        height: 50px;
        background: rgb(241, 244, 249);
      }
    }

    .mblogin {
      .el-input__inner {
        border-radius: 5px;
        height: 50px;
        padding-left: 50px;
        background: rgb(241, 244, 249);
      }
    }
  }
}

@media screen and (min-width: 2560px) {
  .login {
    .pclogin {
      .el-input__inner {
        border-radius: 5px;
        height: 56px;
        background: rgb(241, 244, 249);
      }
    }

    .mblogin {
      .el-input__inner {
        border-radius: 5px;
        height: 56px;
        padding-left: 50px;
        background: rgb(241, 244, 249);
      }
    }
  }
}

.el-form-item__error {
  color: #f56c6c;
  font-size: 0.75rem;
  line-height: 1;
  padding-top: 0.25rem;
  position: absolute;
  top: 100%;
  /* left: 0; */
  right: 0 !important;
}

.el-button--primary {
  background: #be3c6e !important;
  border: none;
}
</style>
